export default "__VITE_ASSET__DPwHLgZm__"